import { useQuery, type UseQueryOptions } from '@tanstack/react-query'

import { USER_QUERY_KEYS } from '../api/endpoints'
import type { UserApi } from '../api/userApi'
import type { MyProfile } from '../types/user.types'

export interface UseMyProfileOptions {
  api: UserApi
  userId: number
  queryOptions?: Omit<
    UseQueryOptions<MyProfile | null, Error>,
    'queryKey' | 'queryFn'
  >
}

export const useMyProfile = ({
  api,
  userId,
  queryOptions,
}: UseMyProfileOptions) => {
  return useQuery({
    queryKey: USER_QUERY_KEYS.myProfile(userId),
    queryFn: async () => {
      const response = await api.getMyProfile(userId)
      if (!response.ok) {
        throw new Error('Failed to fetch my profile')
      }
      return response.data ?? null
    },
    enabled: userId > 0,
    ...queryOptions,
  })
}
